import React from 'react';
import { observer } from 'mobx-react-lite';
import { Div, Thumbnail, Typography } from '@icecreamsocial/components';
import { useStore } from '../../../utils/hooks';
import { Link } from 'react-router-dom';
import { useBusiness } from '../../providers/Business';
import { formatImageURL } from '../../../utils';

const CompanyLogoLink = () => {
	const store = useStore();
	const { business } = useBusiness();

	if (store.Orchestrators.Auth.role !== 'client') return null;

	const { data, isLoading } = business;

	if (isLoading) return <Div
		as={Link}
		to="/settings"
		display="flex"
		alignItems="center"
		textDecoration="none"
		textColor="body"
	>
		<Div
			optimistic
			elWidth="32px"
			elHeight="32px"
			marginRight="md"
			backgroundColor="ambientDark"
			borderRadius="5px"
		/>
		<Typography.Span
			optimistic
			elWidth="75px"
			elHeight="1em"
			borderRadius="5px"
		/>
	</Div>;

	if (!data) return null;

	const { logo, name } = data;
	const url = formatImageURL(logo);


	return (
		<Div
			as={Link}
			to="/settings"
			display="flex"
			alignItems="center"
			textDecoration="none"
			textColor="body"
		>
			{url && (
				<Thumbnail
					marginRight="md"
					elWidth="32px"
					elHeight="32px"
					src={url}
				/>
			)}
			<Typography.Span>{name}</Typography.Span>
		</Div>
	);
};

CompanyLogoLink.displayName = 'CompanyLogoLink';

export default observer(CompanyLogoLink);
